<template>
	<ProgressSpinner v-if="!role"/>
	<Container class="pt-6" v-if="role">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>{{ role.name ?? $route.params.role }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="$emit('on-save')"
				@on-delete="$emit('on-delete')"
				:role="role"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useRolesStore } from "@/stores/roles.js";
import Container from "@/Components/Container.vue";


export default {
	name: "RoleView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			role: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
	watch: {
		'$route.params.role': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.role === 'NEW'){
						this.role = {};
					} else {
						this.role = await this.rolesStore.showRole(this.$route.params.role);
					}
				} else {
					this.role = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useRolesStore),
		tabs() {
			return [
				{
					label: this.$t('pages.admin.users.roles.role.role_view.summary'),
					current: this.$route.name === 'admin.users.roles.role',
					to: {name: 'admin.users.roles.role', params: this.$route.params},
				},
				{
					label: this.$t('pages.admin.users.roles.role.role_view.permissions'),
					current: this.$route.name === 'admin.users.roles.role.permissions',
					to: {name: 'admin.users.roles.role.permissions', params: this.$route.params},
					isActive: this.$route.params.role !== 'NEW',
				},
			].filter(r => r.isActive === undefined || r.isActive)
		}
	},
}
</script>